import { Module } from 'vuex';

import tool from '@/utils/tool';
import RootModuleTypes from '@/store/interface';
import InformationModuleTypes from '@/store/modules/middleGround/my/information/interface';

const informationModule: Module<InformationModuleTypes, RootModuleTypes> = {
    namespaced: true,
    state: {
    },
    mutations: {
    },
    actions: {
        updateMyInfo(context, params) {
            return new Promise((resolve, reject) => {
                tool.post("/personalCenter/updateMyInfo", params).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
    },
};

export default informationModule;